import React from 'react';
import { useTour } from './TourProvider';
import { useUserProfile } from '@/services/python-api/authHooks.js';

const TourBanner = () => {
  const { isTourActive, endTour } = useTour();
  const { data: user } = useUserProfile({ enabled: isTourActive });

  if (!isTourActive || user?.completed_tour) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-blue-50 border-b border-blue-200 px-4 py-3 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4">
        <span className="text-gray-700 text-sm">
          You are in Tour Mode.
        </span>
        <button
          onClick={endTour}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
        >
          End the Tour
        </button>
      </div>
    </div>
  );
};

export default TourBanner;